import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const MentionsLegalesPage = () => {
  return (
    <div className="min-h-screen bg-[#F0F7FA]">
      <div className="bg-gradient-to-r from-[#033871] to-[#0C63BF] py-6">
        <div className="max-w-3xl mx-auto px-4">
          <Link to="/" className="text-[#B8D4E3] text-sm flex items-center gap-1 mb-2 hover:text-white"><ArrowLeft className="w-4 h-4" /> Retour</Link>
          <h1 className="text-2xl font-bold text-white">Mentions Légales</h1>
          <p className="text-sm text-[#B8D4E3] mt-1">Dernière mise à jour : 10 mars 2026</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl border border-[#D6E8F0] p-6 sm:p-8 prose prose-sm max-w-none text-[#033871]">

          <h2 className="text-lg font-bold text-[#033871] mt-0">1. Éditeur du site</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Le site <strong>PadSmash</strong> (ci-après "le Site") est édité par :<br />
            <strong>PadSmash</strong><br />
            Adresse email : <a href="mailto:contact@padsmash.com" className="text-[#0C63BF] hover:underline">contact@padsmash.com</a><br />
            Site internet : <strong>padsmash.com</strong>
          </p>

          <h2 className="text-lg font-bold text-[#033871]">2. Directeur de la publication</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Le directeur de la publication du Site est le représentant légal de PadSmash.<br />
            Contact : <a href="mailto:contact@padsmash.com" className="text-[#0C63BF] hover:underline">contact@padsmash.com</a>
          </p>

          <h2 className="text-lg font-bold text-[#033871]">3. Hébergement</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Le Site est hébergé par :<br />
            <strong>Emergent Labs</strong><br />
            Services d'hébergement cloud
          </p>

          <h2 className="text-lg font-bold text-[#033871]">4. Propriété intellectuelle</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            L'ensemble du contenu du Site (textes, images, logos, graphismes, icônes, sons, logiciels, base de données, etc.) est protégé par les lois françaises et internationales relatives à la propriété intellectuelle. Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du Site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de PadSmash.
          </p>
          <p className="text-[#5A8BA8] leading-relaxed">
            Le logo PadSmash, la marque "PadSmash" et le slogan "Achetez, vendez, smashez !" sont des propriétés de PadSmash. Toute utilisation non autorisée est interdite.
          </p>

          <h2 className="text-lg font-bold text-[#033871]">5. Protection des données personnelles (RGPD)</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Conformément au Règlement Général sur la Protection des Données (RGPD) du 25 mai 2018 et à la loi Informatique et Libertés du 6 janvier 1978 modifiée, les utilisateurs disposent des droits suivants sur leurs données personnelles :
          </p>
          <ul className="text-[#5A8BA8] space-y-1">
            <li><strong>Droit d'accès :</strong> obtenir la confirmation que des données vous concernant sont traitées et en obtenir une copie</li>
            <li><strong>Droit de rectification :</strong> demander la correction des données inexactes ou incomplètes</li>
            <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données dans les conditions prévues par la réglementation</li>
            <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré et couramment utilisé</li>
            <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données pour des motifs légitimes</li>
            <li><strong>Droit à la limitation :</strong> demander la limitation du traitement dans certains cas</li>
          </ul>
          <p className="text-[#5A8BA8] leading-relaxed">
            Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@padsmash.com" className="text-[#0C63BF] hover:underline">contact@padsmash.com</a>
          </p>

          <h2 className="text-lg font-bold text-[#033871]">6. Données collectées</h2>
          <p className="text-[#5A8BA8] leading-relaxed">Dans le cadre de l'utilisation du Site, les données suivantes peuvent être collectées :</p>
          <ul className="text-[#5A8BA8] space-y-1">
            <li><strong>Données d'identification :</strong> nom, prénom, adresse email, numéro de téléphone</li>
            <li><strong>Données d'adresse :</strong> adresse postale, code postal, ville (nécessaires pour la livraison)</li>
            <li><strong>Données de transaction :</strong> historique des achats et ventes, montants des transactions</li>
            <li><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages consultées</li>
          </ul>
          <p className="text-[#5A8BA8] leading-relaxed">
            Ces données sont collectées pour les finalités suivantes : gestion des comptes utilisateurs, traitement des commandes, envoi de notifications, amélioration du service, et respect des obligations légales.
          </p>

          <h2 className="text-lg font-bold text-[#033871]">7. Durée de conservation des données</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Les données personnelles sont conservées pendant la durée de la relation commerciale et pendant une période de 3 ans à compter de la dernière activité sur le compte. Les données liées aux transactions sont conservées pendant 10 ans conformément aux obligations comptables et fiscales.
          </p>

          <h2 className="text-lg font-bold text-[#033871]">8. Sous-traitants et transferts de données</h2>
          <p className="text-[#5A8BA8] leading-relaxed">Pour le bon fonctionnement de la plateforme, certaines données sont partagées avec nos partenaires :</p>
          <ul className="text-[#5A8BA8] space-y-1">
            <li><strong>Stripe :</strong> traitement des paiements (données bancaires). Stripe est certifié PCI-DSS niveau 1.</li>
            <li><strong>Sendcloud :</strong> gestion de la logistique et des expéditions (nom, adresse de livraison).</li>
            <li><strong>Resend :</strong> envoi des emails transactionnels (adresse email).</li>
          </ul>

          <h2 className="text-lg font-bold text-[#033871]">9. Cookies</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Le Site utilise des cookies strictement nécessaires au fonctionnement du service (authentification, préférences). Aucun cookie publicitaire ou de suivi n'est utilisé. En utilisant le Site, vous acceptez l'utilisation de ces cookies techniques.
          </p>

          <h2 className="text-lg font-bold text-[#033871]">10. Prestataire de paiement</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Les transactions financières sont gérées par <strong>Stripe</strong>, prestataire de services de paiement agréé. Stripe traite les données bancaires dans un environnement sécurisé conforme aux normes PCI-DSS. PadSmash n'a jamais accès aux numéros de carte bancaire des utilisateurs.
          </p>

          <h2 className="text-lg font-bold text-[#033871]">11. Limitation de responsabilité</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            PadSmash met tout en œuvre pour assurer l'exactitude et la mise à jour des informations diffusées sur le Site. Toutefois, PadSmash ne peut garantir l'exactitude, la complétude ou l'actualité des informations publiées par les utilisateurs (annonces, descriptions, photos). PadSmash ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation du Site ou de l'impossibilité de l'utiliser.
          </p>

          <h2 className="text-lg font-bold text-[#033871]">12. Liens hypertextes</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Le Site peut contenir des liens vers d'autres sites internet. PadSmash n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
          </p>

          <h2 className="text-lg font-bold text-[#033871]">13. Droit applicable</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Les présentes mentions légales sont régies par le droit français. En cas de litige relatif à l'interprétation ou l'exécution des présentes, les tribunaux français seront seuls compétents.
          </p>

          <h2 className="text-lg font-bold text-[#033871]">14. Contact</h2>
          <p className="text-[#5A8BA8] leading-relaxed">
            Pour toute question concernant les présentes mentions légales, vous pouvez nous contacter à :<br />
            <a href="mailto:contact@padsmash.com" className="text-[#0C63BF] hover:underline font-semibold">contact@padsmash.com</a>
          </p>

        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
